var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
// Default link component
var Link = function (_a) {
    var to = _a.to, children = _a.children, props = __rest(_a, ["to", "children"]);
    return (React.createElement("a", __assign({ href: to }, props), children));
};
export var LinkContext = React.createContext(Link);
/**
 * This HOC makes possible to use custom links transmitted through react context api (check usage in Menu.tsx)
 */
export default function withCustomLink(Component) {
    return function ConnectedComponent(props) {
        return (React.createElement(LinkContext.Consumer, null, function (customLinkTag) { return React.createElement(Component, __assign({}, props, { customLinkTag: customLinkTag })); }));
    };
}
//# sourceMappingURL=withCustomLink.js.map